import { createContext, useContext } from 'react';

export type Theme = 'light' | 'dark' | 'system';

export interface DarkModeContextValue {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  isDark: boolean;
}

export const DarkModeContext = createContext<DarkModeContextValue>({
  theme: 'system',
  setTheme: () => {},
  isDark: false,
});

export function useDarkMode() {
  return useContext(DarkModeContext);
}

const STORAGE_KEY = 'fy_theme';

export function getStoredTheme(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark' || stored === 'system') return stored;
  return 'system';
}

export function storeTheme(theme: Theme) {
  localStorage.setItem(STORAGE_KEY, theme);
}

export function applyTheme(theme: Theme) {
  const isDark =
    theme === 'dark' ||
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

  document.documentElement.classList.toggle('dark', isDark);
  return isDark;
}
